import React from 'react'
import PropTypes from 'prop-types'

import StatusIndicator from './StatusIndicator'

import PrintIcon from '@material-ui/icons/Print';
import PrintDisabledIcon from '@material-ui/icons/PrintDisabled';

const PrintIndicator = ({ available, className, ...props }) => {
  let icon = null

  if (available) {
    icon = <PrintIcon style={{ color: "white" }} />
  }

  return <StatusIndicator {...props} className={className} icon={icon} />
}

PrintIndicator.defaultProps = {
  available: false,
}

PrintIndicator.propTypes = {
  available: PropTypes.bool,
}

export default PrintIndicator
